import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

// First-paint fallback width for RenderHTML before onLayout measures the
// real container. Matches the patient Modal shell's maxWidth.
export const MODAL_MAX_WIDTH = 768;
export const CONTENT_PADDING = theme.spacings.md;

export const styles = StyleSheet.create({
  wrapper: {
    padding: CONTENT_PADDING,
  },
});

// Plain object (not a StyleSheet) — RenderHTML's tagsStyles takes raw CSS.
const sharedText = {
  fontSize: theme.fontSizes.xl,
  lineHeight: 40,
  color: theme.colors.newUI.therapist.textBlue100,
};

export const htmlTagStyles = {
  body: sharedText,
  strong: { ...sharedText, fontWeight: 'bold' as const },
  p: { ...sharedText, marginBottom: 16 },
};
